import { Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Playlist } from '@app/library/models/playlist.model';
import { LibraryBacHelperService } from '@app/library/services/library-bac-helper.service';
import { PlaylistsState } from '@app/library/states/playlists.state';
import { SelectedTracksState } from '@app/library/states/selected-tracks.state';
import { DndDropEvent } from '@app/shared/modules/dnd/directives/dnd-dropzone.directive';
import { Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

import { AddToPlaylistRequest } from './../../../states/playlists.actions';

@Component({
  selector: 'rk-playlist-list-line',
  templateUrl: './playlist-list-line.component.html',
  styleUrls: ['./playlist-list-line.component.scss'],
})
export class PlaylistListLineComponent implements OnInit, OnDestroy {
  @Input()
  playlist: Playlist;

  @HostBinding('class.active')
  public isActive: boolean;

  @HostBinding('class.no-bar')
  @Input()
  disableBar: boolean;

  @Input()
  radioId: number;

  @Input()
  updating = false;

  processing$: Observable<boolean>;

  subscription = new Subscription();

  constructor(
    private readonly router: Router,
    private readonly uiHelper: LibraryBacHelperService,
    private readonly store: Store,
  ) {}

  ngOnInit() {
    // Listen for route changes
    this.subscription.add(
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          if (!event.urlAfterRedirects) {
            return;
          }
          this.checkForClasses(event.urlAfterRedirects);
        }
      }),
    );
    this.processing$ = this.store
      .select(PlaylistsState.playlistProcessing)
      .pipe(map(fn => fn(this.playlist.id)));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  checkForClasses(url: string): void {
    // set the active route or not
    this.isActive = this.uiHelper.isPlaylistActive(url, this.playlist);
  }

  dropped(event: DndDropEvent) {
    const selectedTracks = this.store.selectSnapshot(SelectedTracksState.selectedTracks);
    if (selectedTracks.indexOf(event.data.id) > -1 && selectedTracks.length > 1) {
      this.store.dispatch(new AddToPlaylistRequest(this.playlist.id, selectedTracks));
    } else {
      const selectedPlayTracks = this.store.selectSnapshot(
        SelectedTracksState.selectedPlayTracks,
      );
      if (selectedPlayTracks.length > 0) {
        const ids = selectedPlayTracks.map(i => i.id);
        this.store.dispatch(new AddToPlaylistRequest(this.playlist.id, ids));
      } else {
        this.store.dispatch(new AddToPlaylistRequest(this.playlist.id, [event.data.id]));
      }
    }
  }
}
